import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { File as FileIcon } from '@/components/Icons/File';
import styles from './Message.module.scss';
export const File = ({ url, name }) => {
    return (_jsx(_Fragment, { children: _jsxs("a", { className: styles.file, title: name, href: url, target: "_blank", rel: "noreferrer", children: [_jsx(FileIcon, { size: 16 }), '\u00A0', name || url] }) }));
};
